import React from 'react';
import Section from '../common/Section';
import styles from '../../styles/modules/components/coverage-details.module.scss';
import Hidden from '@mui/material/Hidden';
import theme from '../mui-overrides';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import Image from '../common/Image';

interface MainProps {
    title: string,
    subtitle: string,
    image: string,
    data: any[]
}
interface ListProps {
    number: string,
    para: string
}

const CoverageDetails = (props: MainProps) => {

    return (
        <Section className={styles.contains}>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <div className="container" id="coverage-details">
                        <div className="row">
                            <Hidden lgUp>
                                <div className="col-12 col-lg-12">
                                    <h4>{props.title}</h4>
                                </div>
                                <div className="col-12 col-lg-12">
                                    <h5>{props.subtitle}</h5>
                                </div>
                                <div className={`${styles._image} col-12 col-lg-7`}>
                                    <Image src={`/static/images/CoverageDetails/` + props.image} alt={"placeholder"} width="700" height="700"  />
                                </div>
                            </Hidden>
                            <Hidden lgDown>
                                <div className={`${styles._image} col-12 col-lg-7`}>
                                    <Image src={`/static/images/CoverageDetails/` + props.image} alt={"placeholder"} width="641" height="551"  />
                                </div>
                            </Hidden>
                            <div className={`col-12 col-lg-5 ${styles._deskptop_card}`}>
                                <Hidden lgDown>
                                    <h4>{props.title}</h4>
                                    <h5>{props.subtitle}</h5>
                                </Hidden>
                                {props.data && props.data.map((item, index) => {
                                    return <ListItems key={index} number={item.number} para={item.paragraph} />
                                })}
                            </div>
                        </div>
                    </div>
                </ThemeProvider>
            </StyledEngineProvider>
        </Section>
    );
}

const ListItems = (props: ListProps) => {
    return (
        <div className={`${styles._card} `}>
            <span className={`${styles._listnumbers} col-2 col-lg-2`}>{props.number}</span>
            <p className={`${styles._text} col-10 col-lg-10`}>{props.para}</p>
        </div>
    )
}
export default CoverageDetails
